<ats-modal-template [width]="350">
  <div atsTemplate="header">Pomodoro timer settings</div>
  <div atsTemplate="content">
    @if(loading()) {
      <div class="col-12 flex justify-content-around">
        <i class="i i-spin i-spinner text-4xl p-4" style="color: var(--gray-600)"></i>
     </div>
    } @else {
    <form [formGroup]="form">
      <ats-inputtext
        type="extended"
        postfix="min"
        formControlName="workDuration"
        placeholder="Work duration"></ats-inputtext>
      <ats-inputtext
        type="extended"
        postfix="min"
        formControlName="shortBreakDuration"
        placeholder="Short break duration"></ats-inputtext>
      <ats-inputtext
        type="extended"
        postfix="min"
        formControlName="longBreakDuration"
        placeholder="Long break duration"></ats-inputtext>
      <ats-inputtext
        type="extended"
        tip="When the number of iterations is reached, the long break will start. Must be even number."
        postfix="iterations"
        formControlName="iterationCount"
        placeholder="Iteration count"></ats-inputtext>
      <ats-checkbox-wide
        width="302px"
        formControlName="needConfirm"
        label="Show confirm"
        tip="When the timer is finished, a confirmation window will appear"></ats-checkbox-wide>
      <ats-checkbox-wide
        width="302px"
        formControlName="needSound"
        label="Play sound"
        tip="The timer will play a sound when the iteration is finished"></ats-checkbox-wide>
      </form>
    }
  </div>
  <div atsTemplate="footer" class="flex">
    <ats-button label="Cancel" class="mr-2" serverity="outlined" (click)="close()"></ats-button>
    <ats-button label="Save" (click)="save()" [disabled]="loading()"></ats-button>
  </div>
</ats-modal-template>
